/** Small text helpers shared by the join and roster screens. */
import { normalizeName } from '@engine/index.ts';
import { CLASS_CODE_ALPHABET, CLASS_CODE_LENGTH } from '@shared/protocol.ts';

/** Upper-cases a typed class code and keeps only characters from the class-code alphabet. */
export function cleanCode(raw: string): string {
  return raw
    .toUpperCase()
    .split('')
    .filter((ch) => CLASS_CODE_ALPHABET.includes(ch))
    .join('')
    .slice(0, CLASS_CODE_LENGTH);
}

/** Turns a pasted class list into unique "First L." names (blank lines and repeats dropped). */
export function parseNames(text: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const line of text.split(/\r?\n/)) {
    const n = normalizeName(line);
    if (!n || seen.has(n.toLowerCase())) continue;
    seen.add(n.toLowerCase());
    out.push(n);
  }
  return out;
}

/** Ends a phrase with exactly one period (engine strings sometimes already end with one). */
export function sentence(s: string): string {
  const t = s.trim();
  return /[.!?]$/.test(t) ? t : `${t}.`;
}
